import { Action } from '@ngrx/store';

export enum TranslationActionTypes {
    LOAD_TRANSLATION = '[Translation] Load Translation',
    LOAD_TRANSLATION_SUCCESS = '[Translation] Load Translation Success',
    LOAD_TRANSLATION_ERROR = '[Translation] Load Translation Error',
    CLEAR_TRANSLATIONS = '[Translation] Clear Translations',
    CHANGE_LOCALE = '[Translation] Change Locale',
}

export class LoadTranslationAction implements Action {
    readonly type = TranslationActionTypes.LOAD_TRANSLATION;
    constructor(public payload: { lang: string }) {}
}

export class LoadTranslationSuccessAction implements Action {
    readonly type = TranslationActionTypes.LOAD_TRANSLATION_SUCCESS;
    constructor(public payload: { lang: string; translations: any }) {}
}

export class LoadTranslationErrorAction implements Action {
    readonly type = TranslationActionTypes.LOAD_TRANSLATION_ERROR;
    constructor(public payload: { lang: string; error: any }) {}
}

export class ClearTranslationsAction implements Action {
    readonly type = TranslationActionTypes.CLEAR_TRANSLATIONS;
}

export class ChangeLocaleAction implements Action {
    readonly type = TranslationActionTypes.CHANGE_LOCALE;
    constructor(public payload: { locale: string }) {}
}

export type TranslationActions =
    | LoadTranslationAction
    | LoadTranslationSuccessAction
    | LoadTranslationErrorAction
    | ClearTranslationsAction
    | ChangeLocaleAction;
